
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.331 11.213A3.98 3.98 0 0016 9.001c0-2.206-1.794-4-4-4H9.5c-1.93 0-3.5 1.57-3.5 3.5v7c0 1.929 1.57 3.5 3.5 3.5h4.545c2.181 0 3.955-1.774 3.955-4.03 0-1.062-.41-2.06-1.155-2.808a3.94 3.94 0 00-1.514-.95zM8 8.5C8 7.673 8.673 7 9.5 7H12c1.103 0 2 .897 2 2s-.897 2-2 2H8V8.499zm6.045 8.501H9.5c-.827 0-1.5-.674-1.5-1.5v-2.5h6.048c.521 0 1.011.203 1.379.573.369.371.573.867.573 1.472a1.957 1.957 0 01-1.955 1.955zM19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5zm3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v14z"}})])
          )
        }
      }
    